import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[app-narrow-sidebar-profile-image]',
})
export class NarrowSidebarProfileImageDirective {
  @HostBinding('class') class = 'size-8 rounded-full bg-gray-50 outline -outline-offset-1 outline-black/5';
}
